import { type RouteObject } from 'react-router-dom';

import { ROUTES_PATH } from '@/constants/routes.constants';

const FaqRoutes: RouteObject[] = [
  { path: ROUTES_PATH.faq, lazy: () => import('./dashboard') },
];

export { FaqRoutes };
